<template>
  <v-container fluid>
    <base-card
      color="indigo"
      icon="mdi-briefcase"
      inline
      class="px-5 py-3"
      title="Настройки Workflow"
    >
      <v-tabs>
        <v-tab v-for="item in items" :key="item.guid">{{ item.name }}</v-tab>
        <v-tab-item v-for="item in items" :key="item.guid">
          <v-row>
            <v-col
              v-for="data in item.settings_data"
              :key="data.guid"
              cols="12" lg="6"
            >
              <v-text-field
                v-model="data.val"
                :label="data.name"
                append-icon="mdi-check"
                @click:append="change(data, item.group)"
                type="number"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
    </base-card>
  </v-container>
</template>

<script>
export default {
  name: 'SettingsCommonEmail',
  data: () => ({
    items: []
  }),
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.$store.dispatch('settings/GET_SETTINGS', 'common_email').then(response => {
        this.items = response
      })
    },
    change (item, group) {
      if (!item.val) return
      const payload = {
        guid: item.guid,
        value: item.val,
        group: group
      }
      this.$store.dispatch('settings/POST_SETTING', payload).then(() => {
        this.flashMessage.success({ title: 'Сохранение', message: 'Настройка успешно сохранена.' })
      })
    }
  }
}
</script>

<style scoped>

</style>
